// Referral link (?ref=...) capture for employee attribution.
// First-touch: the earliest ?ref seen on this browser wins and is reused for the
// whole multi-step registration. Sent to the backend on signup + application save.
const REF_KEY = "usat_ref";

export function captureRef(query) {
  const ref = query && query.ref;
  if (ref && !localStorage.getItem(REF_KEY)) {
    localStorage.setItem(REF_KEY, String(ref));
  }
}

export function getRef() {
  return localStorage.getItem(REF_KEY) || undefined;
}

export function clearRef() {
  localStorage.removeItem(REF_KEY);
}
